import React from 'react'
import PropTypes from 'prop-types'

import Table from 'shared/components/Table'
import Popup from 'shared/components/Popup'
import { DomainStatusBadge } from 'components/DomainRow'
import { getAntdColumnMaxWidth } from 'libs/table/utils'

const EMPTY_TEXT = "You haven't added any sending domains yet."

const domainColumns = [
  {
    title: 'Domain',
    dataIndex: 'domain',
    key: 'domain',
    ...getAntdColumnMaxWidth(400),
    render: (domain) => <Popup.Truncated content={domain} />,
  },
  {
    title: 'Status',
    key: 'status',
    width: 140,
    render: (_, record) => (
      <DomainStatusBadge
        valid={record.valid}
        lastValidationAttemptAt={record.last_validation_attempt_at}
      />
    ),
  },
]

export const DomainsPresentation = ({ domains, error, onRowClick }) => (
  <div className="ui stackable grid">
    <div className="row">
      <div className="sixteen wide column">
        <p>
          Email authentication helps to prove your emails are not forgeries, prevents delivery
          issues, and protects your sender reputation.
        </p>
        <p>
          <a
            href="https://help.simplesat.io/en/articles/2207534-authenticating-domains-for-email-delivery"
            target="_blank"
            rel="noreferrer"
          >
            <i className="icon far fa-book" />
            Authenticating domains for email delivery
          </a>
        </p>
        <Table
          variant="indexPage"
          clickable
          rowKey="id"
          columns={domainColumns}
          dataSource={error ? [] : domains}
          locale={{ emptyText: EMPTY_TEXT }}
          onRow={(record) => ({ onClick: () => onRowClick(record.id) })}
        />
      </div>
    </div>
  </div>
)

DomainsPresentation.propTypes = {
  domains: PropTypes.arrayOf(PropTypes.object),
  error: PropTypes.bool,
  onRowClick: PropTypes.func.isRequired,
}

DomainsPresentation.defaultProps = {
  domains: [],
  error: false,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/EmailSetting/index.js